import { Button } from '@/components/tiptap-editor/tiptap-ui-primitive/button';
import { ButtonGroup } from '@/components/tiptap-editor/tiptap-ui-primitive/button-group';
import { Lock, RefreshCcw, Unlock } from 'lucide-react';

export interface ZyVersionScrollLockButtonProps {
    isSyncScroll: boolean;
    onToggleSyncScroll: () => void;
    onSyncScroll: () => void;
}

export function ZyVersionScrollLockButton({ isSyncScroll, onToggleSyncScroll, onSyncScroll }: ZyVersionScrollLockButtonProps) {
    return (
        <ButtonGroup orientation="horizontal">
            <Button
                type="button"
                data-style="ghost"
                data-active-state={isSyncScroll ? 'on' : 'off'}
                aria-pressed={isSyncScroll}
                onClick={onToggleSyncScroll}
                aria-label={isSyncScroll ? 'Unlock scroll' : 'Lock scroll'}
                tooltip={isSyncScroll ? 'Unlock scroll' : 'Lock scroll'}
            >
                {isSyncScroll ? (
                    <Lock
                        className="tiptap-button-icon size-4"
                        aria-hidden
                    />
                ) : (
                    <Unlock
                        className="tiptap-button-icon size-4"
                        aria-hidden
                    />
                )}
            </Button>
            <Button
                type="button"
                data-style="ghost"
                aria-label="Sync scroll"
                disabled={isSyncScroll}
                tooltip={isSyncScroll ? 'Scroll is locked' : 'Sync scroll'}
                onClick={onSyncScroll}
            >
                <RefreshCcw className="tiptap-button-icon size-4" />
            </Button>
        </ButtonGroup>
    );
}

export default ZyVersionScrollLockButton;
